module.exports = __webpack_public_path__ + "img/bg1-min.3fe2b797.jpg";